import { render, staticRenderFns } from "./ReferrerCard.vue?vue&type=template&id=177f8fb4"
import script from "./ReferrerCard.vue?vue&type=script&lang=js"
export * from "./ReferrerCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports